/*
*
* @module : Home
* @file : Home.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of Home
*
* Created on : 09-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 19-Oct-2019
*/

import React from 'react';
import {Link} from 'react-router-dom';
import Translation from '../../language/Translation';

class Home extends React.Component
{
	constructor(props)
	{
		super(props);
		this.translation = new Translation();
		this.state = {
			translation:{
				'home_v1':this.translation.getText('home_v1'),
				'home_v2':this.translation.getText('home_v2'),
				'home_v3':this.translation.getText('home_v3'),
				'home_v4':this.translation.getText('home_v4'),
				'home_v5':this.translation.getText('home_v5'),

			}
		}
		sessionStorage.clear();
		
	}

	componentDidMount()
	{

	}

	render()
	{
		return (
			<React.Fragment>
				<div className="content-box-area">
				<div className="default-heading">
				<h2>{this.state.translation.home_v1}</h2>
				<h2>{this.state.translation.home_v5}</h2>
				</div>
				<div className="paragraph-area">
				<p>{this.state.translation.home_v2}</p>
				<p> {this.state.translation.home_v3}</p>
				</div>
				<div className="text-center buttons-area">
				<Link to="/topics" className="btn btn-primary">{this.state.translation.home_v4}</Link>
				</div>
				</div>
			</React.Fragment>
		);
	}
}

export default Home;